import { Injectable } from '@angular/core';
import { TenantSocketEvent } from '@jms/model';
import { ConfigService } from '@jms/ui/ui.standalone.services/config.service';;
import { BehaviorSubject, fromEvent, Observable, Subject, takeUntil, tap } from 'rxjs';
import { io, Socket } from 'socket.io-client';

@Injectable({ providedIn: 'root' })
export class SocketConnection {

    public readonly socket: Socket;
    public readonly connected$ = new Subject<void>();

    constructor() {

        const config = ConfigService.environment;
        this.socket = io(`https://${config.tenant}.${config.domain}`, {
            path: '/api/socket-io',
            transports: ['websocket'],
            auth: (cb: any) => {
                setTimeout(() => {
                    cb({ token: localStorage.getItem('auth_token') });
                })
            }
        });

        this.socket.on('connected', () => {
            console.log('connected');
            this.connected$.next();
        });

        this.socket.io.on('reconnect', () => {
            console.log('reconnect');
            this.connected$.next();
        });


    }

    public join(room: string): SocketRoom {
        const socket = this.socket;
        return new SocketRoom(socket, room, this.connected$);
    }

}

export class SocketRoom {

    protected readonly _leave$ = new Subject<void>();
    public readonly data$: Observable<any>;

    constructor(
        public readonly socket: Socket,
        public readonly room: string,
        private readonly connected$: Observable<void>
    ) {
        this.socket.emit('join', this.room);

        this.data$ = fromEvent(this.socket, TenantSocketEvent.Message)
            .pipe(
                takeUntil(this._leave$)
            );

        this.connected$
            .pipe(
                takeUntil(this._leave$),
                tap(() => {
                    console.log('reconnecting and joining room');
                    this.socket.emit('join', this.room)
                })
            )
            .subscribe();

    }

    public leave() {
        this.socket.emit('leave', this.room);
        this._leave$.next();
    }

}